module.exports = __webpack_public_path__ + "static/media/hell.d451ae0f.gif";